import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "uq-preloader"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loader loader--3" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "center-main-container d-flex align-items-center w-100"
}
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "h4 title fw-normal mb-40 text-primary" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "form mb-48" }
const _hoisted_9 = { class: "mb-40 text-primary" }
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = { class: "row mb-48" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-phone me-16",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "col"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-message me-16",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "text-primary fw-bold text-md"
}
const _hoisted_17 = { class: "text-xxl" }
const _hoisted_18 = { class: "form mb-48" }
const _hoisted_19 = { class: "mb-40 text-primary" }
const _hoisted_20 = { class: "d-flex mb-24" }
const _hoisted_21 = ["aria-label", "title"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-import me-16",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-arrow-right-long me-16",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_24 = { class: "form-actions text-end" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-arrow-right-long me-8",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!

  return (!_ctx.currentExpedient && _ctx.status === 'loading')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t('Protección de')) + " ", 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('datos')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", null, _toDisplayString(// eslint-disable-next-line max-len
              _ctx.$t('Para poder continuar con el proceso es necesario que el paciente acepte la información de protección de datos. Para ello, puedes enviarla mediante las dos opciones disponibles.')), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(// eslint-disable-next-line max-len
              _ctx.$t('En caso de que el paciente no haya recibido notificación alguna, puede reenviarlo pinchando de nuevo en una de las opciones. En el momento en el que el paciente acepte la política, podrá acceder a su ficha para completar sus datos pinchando en “continuar”.')), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_v_button, {
                  variant: "primary",
                  size: "md",
                  class: "btn-icon w-100",
                  "aria-label": _ctx.$t('Enviar RGPD mediante SMS'),
                  disabled: _ctx.rgpdSent,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sendNotification('sms')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Enviar RGPD mediante SMS')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "disabled"])
              ]),
              (_ctx.patientDoesntHaveEmail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_v_button, {
                      variant: "primary",
                      size: "md",
                      class: "btn-icon w-100",
                      "aria-label": _ctx.$t('Enviar RGPD mediante Email'),
                      disabled: _ctx.rgpdSent,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sendNotification('mail')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Enviar RGPD mediante email')), 1)
                      ]),
                      _: 1
                    }, 8, ["aria-label", "disabled"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!!_ctx.rgpdSent)
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                  _createTextVNode(_toDisplayString(_ctx.$t('La notificación se ha enviado. En caso de no recibirla, podrás volver a enviarla dentro de:')) + " ", 1),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formattedTimer), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", null, _toDisplayString(// eslint-disable-next-line max-len
              _ctx.$t('También se puede imprimir en papel la RGPD y que el paciente la lea y firme en persona. Para ello, descarga e imprime el documento pulsando el botón "Descargar para imprimir", y, a continuación, pulsa en el botón "Paciente ha firmado RGPD en papel".')), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("a", {
                class: "btn btn-danger btn-icon btn-md me-32",
                target: "_blank",
                href: "https://drive.google.com/uc?export=download&id=1D1M_dEUdns7lWO1tHCGHMzEOxO3WBSqw",
                "aria-label": _ctx.$t('Descargar para imprimir'),
                title: _ctx.$t('Descargar')
              }, [
                _hoisted_22,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('Descargar para imprimir')), 1)
              ], 8, _hoisted_21),
              _createVNode(_component_v_button, {
                variant: "secondary",
                size: "md",
                class: "btn-icon",
                "aria-label": _ctx.$t('Paciente ha firmado RGPD en papel'),
                onClick: _ctx.acceptRGPD
              }, {
                default: _withCtx(() => [
                  _hoisted_23,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Paciente ha firmado RGPD en papel')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_v_button, {
              variant: "secondary",
              class: "btn-icon",
              "aria-label": _ctx.$t('Ir al expediente'),
              title: "Ir al expediente",
              onClick: _ctx.refreshCurrentExpedient
            }, {
              default: _withCtx(() => [
                _hoisted_25,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('Continuar')), 1)
              ]),
              _: 1
            }, 8, ["aria-label", "onClick"])
          ])
        ])
      ]))
}